import React, { useContext } from 'react';
import styled from '@emotion/styled';
import '@fontsource/merriweather/400.css';
import '@fontsource/merriweather/900.css';
import API from '@lib/API';
import useDeviceDetect from '@hooks/useDeviceDetect';

function StickyCard({ isVisible, onClose }) {
  const AuthAPI = new API();
  const { deviceType } = useDeviceDetect();

  const openSignup = () => {
    AuthAPI.sendAmplitudeEvent('Click Signup', {
      btnPosition: 'Blog Sticky Card',
    });
    window.open('https://bit.ly/3Hg02N0');
  };

  return deviceType === 'desktop' ? (
    <StickyCardWrapper
      className={
        'sticky-card px-4 lg:px-0 desktop ' + (isVisible ? 'show' : 'hide')
      }
    >
      <button onClick={onClose} className="cross-button" />
      <span className="link" onClick={openSignup}>
        <div className="card-content">
          <img
            src="https://d1nc6vzg2bevln.cloudfront.net/images/general/blog-right-banner-1.png"
            alt="InVideo"
          />
        </div>
      </span>
    </StickyCardWrapper>
  ) : (
    <StickyCardWrapper
      className={
        'sticky-card px-4 lg:px-0 mobile ' + (isVisible ? 'show' : 'hide')
      }
    >
      <button onClick={onClose} className="cross-button" />
      <div className="card-content" onClick={openSignup}>
        <h3 className="primary-text">
          Create PRO videos in minutes with InVideo
        </h3>
        <button className="btn-signup">Get Started - It's FREE</button>
      </div>
    </StickyCardWrapper>
  );
}

export default StickyCard;

const StickyCardWrapper = styled.section`
  position: fixed;
  width: 18%;
  right: -18%;
  //height: calc(100% - 5rem);
  top: 35%;
  height: 430px;
  opacity: 0;

  &.hide {
    animation: slideOutRight .5s ease-in both;
  }

  &.show {
    animation: slideInRight .5s ease-in both;
  }

  .link {
    cursor: pointer;
  }

  .card-content {
    position: sticky;
    margin-bottom: 7rem;
    color: #FFF;
    opacity: 1;
    transition: opacity 500ms ease 0.5s;
    //background: #201d70;
    //border-radius: 0.5rem;
    //padding: 2.5rem 2rem;
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(64, 87, 109, .07);
    border-radius: 8px;

    img {
      border-radius: 8px;
    }
  }

  h3.primary-text {
    font-size: 20px;
    font-weight: 800;
    letter-spacing: 0.5px;
  }

  .btn-signup {
    padding: 5px 12px;
    font-size: 15px;
    background: #9acc33;
    color: #000;
    border-radius: 20px;
    margin-top: 20px;
    font-weight: 600;
    cursor: pointer;
  }

  .cross-button {
    position: absolute;
    z-index: 5;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    color: #9a9b9c;
    font-size: 16px;
    line-height: 19px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: right;
    background-image: url('https://d1nc6vzg2bevln.cloudfront.net/images/general/cross.svg');

    &:focus {
      outline: none;
    }

    @media (min-width: 578px) {
      display: block;
    }

    @media (min-width: 730px) and (max-width: 1240px) {
      top: 6px;
      right: 22px;
      width: 24px;
      height: 24px;
    }
  }

  @media (min-width: 320px) and (max-width: 1240px) {
    position: relative;
    width: 98%;
    margin: 0 auto;
    right: unset;
    height: calc(100% - 5rem);
    top: unset;
    background: #201d70;
    border-radius: 0.5rem;
    opacity: 1;
    animation: none;
    &.show {
      animation: none;
    }

    &.hide {
      animation: none;
    }

    .card-content {
      position: unset;
      padding: 1.5rem;
      align-items: center;
      flex-direction: row;
      justify-content: space-around;
      margin-bottom: 3rem;

      .cross-button {
        display: block;
      }
    }

    .btn-signup {
      margin-top: 0;
    }
  }

  @media (min-width: 801px) and (max-width: 1240px) {
    width: 800px;
  }

  @media (max-width: 730px) {
    position: fixed;
    bottom: 0;
    max-height: 160px;
    min-height: 120px;
    width: 95%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 0.1rem;
    opacity: 0;
    z-index: 1111;
    &.show {
      animation: slideInBottom .5s ease-in both;
    }

    &.hide {
      animation: slideOutBottom .5s ease-in both;
    }

    .card-content {
      position: unset;
      padding: 1.5rem;
      align-items: start;
      flex-direction: column;
      margin-bottom: 3rem;

      .btn-signup {
        margin-top: 20px;
      }
    }
  }
  @keyframes slideInRight {
    0% {
      right: -18%;
      opacity: 0;
    }
    100% {
      right: 0;
      opacity: 1;
    }
  }
  @keyframes slideOutRight {
    0% {
      right: 0;
      opacity: 1;
    }
    100% {
      right: -18%;
      opacity: 0;
    }
  }
  @keyframes slideInBottom {
    0% {
      bottom: -170px;
      opacity: 0;
    }
    100% {
      bottom: 0;
      opacity: 1;
    }
  }
  @keyframes slideOutBottom {
    0% {
      bottom: 0;
      opacity: 1;
    }
    100% {
      bottom: -170px;
      opacity: 0;
    }
  }
}
`;
